import React from 'react';
import SegmentedControl from '../../components/SegmentedControl/SegmentedControl';
import type { SegmentedControlOption } from '../../components/SegmentedControl/SegmentedControl';
import type { ListViewMode } from '../types';

interface ListViewModeToggleProps {
  viewMode: ListViewMode;
  onViewModeChange: (viewMode: ListViewMode) => void;
}

/* Picks how the bookings are shown: as cards, or as a table. It sits at the
   left of the toolbar's display band, directly above the bookings it governs */
const ListViewModeToggle = ({ viewMode, onViewModeChange }: ListViewModeToggleProps) => {
  const modes: SegmentedControlOption<ListViewMode>[] = [
    { id: 'card', label: i18n('Cards'), icon: 'view-grid' },
    { id: 'table', label: i18n('Table'), icon: 'view-list' }
  ];
  return (
    <div data-test-view-mode-toggle>
      <SegmentedControl
        options={modes}
        value={viewMode}
        onChange={onViewModeChange}
        label={i18n('View mode')}
        collapseOnMobile
      />
    </div>
  );
};

export default ListViewModeToggle;
